import React from 'react'
import PropTypes from 'prop-types'
import { lifecycle } from 'recompose'
import {
    ALIGNER_TREATMENT,
    ALIGNER_TREATMENT_EXPECTATION,
    ALIGNER_TREATMENT_MEDICAL_INFORMATION,
    ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT,
    IMPLANT_CONSULTATION_AND_FINDINGS,
    IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT,
    IMPLANT_TREATMENT,
    IMPLANT_SURGERY_DOCUMENTATION,
} from '../../state/anamnesis/const'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import AlignerTreatmentCustomerAssessment from './renderer/AlignerTreatmentCustomerAssessment'
import AlignerTreatmentPhysicianAssessment from './renderer/AlignerTreatmentPhysicianAssessment'
import ImplantConsultationAndFindings from './renderer/ImplantConslutationAndFindings'
import AlignerTreatmentMedical from './renderer/AlignerTreatmentMedical'
import AlignerTreatmentExpectation from './renderer/AlignerTreatmentExpectation'
import ImplantTreatmentPhysicianAssessment from "./renderer/ImplantTreatmentPhysicianAssessment";
import { formatDateTime } from '../../../../util/datetime'
import { ANAMNESIS_TITLE } from '../../state/const'
import currentUserHasAccess from '../../../../util/widget-helper'
import { ANAMNESIS_EDIT_WIDGET_CONTAINER } from '../../../process/ui-definition/process-ui'
import ImplantSurgeryDocumentation from './renderer/ImplantSurgeryDocumentation'

const AnamnesisRenderer = props => {
    const { anamnesis } = props
    if (anamnesis.templateKey === ALIGNER_TREATMENT) {
        return <AlignerTreatmentCustomerAssessment {...props} />
    }

    if (anamnesis.templateKey === IMPLANT_TREATMENT) {
        return <AlignerTreatmentCustomerAssessment {...props} />
    }

    if (anamnesis.templateKey === ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT) {
        return <AlignerTreatmentPhysicianAssessment {...props} />
    }

    if (anamnesis.templateKey === ALIGNER_TREATMENT_MEDICAL_INFORMATION) {
        return <AlignerTreatmentMedical {...props} />
    }

    if (anamnesis.templateKey === ALIGNER_TREATMENT_EXPECTATION) {
        return <AlignerTreatmentExpectation {...props} />
    }

    if (anamnesis.templateKey === IMPLANT_CONSULTATION_AND_FINDINGS) {
        return <ImplantConsultationAndFindings {...props} />
    }

    if (anamnesis.templateKey === IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT) {
        return <ImplantTreatmentPhysicianAssessment {...props} />
    }

    if (anamnesis.templateKey === IMPLANT_SURGERY_DOCUMENTATION) {
        return <ImplantSurgeryDocumentation {...props} />
    }

    return <div>no {anamnesis.templateKey} renderer for</div>
}

const Author = ({ anamnesis }) => {
    return (
        <Row>
            <Column size={12}>
                <label className="control-label">
                    {anamnesis.createdByUser || ''}{' '}
                    {formatDateTime(anamnesis.created)}
                </label>
            </Column>
        </Row>
    )
}

const Anamnesis = props => {
    const { anamnesis, skipAuthorization = false } = props

    if (!skipAuthorization && !currentUserHasAccess(ANAMNESIS_EDIT_WIDGET_CONTAINER)) {
        return null
    }

    if (!anamnesis) {
        return null
    }

    const title = ANAMNESIS_TITLE[anamnesis.templateKey]

    let shouldRenderHeader = anamnesis.templateKey !== ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT;

    return (
        <ContentBox title={title}>
            {shouldRenderHeader && <Author {...props} />}
            <AnamnesisRenderer {...props} />
        </ContentBox>
    )
}

export default lifecycle({
    componentDidMount () {
        const {
            anamnesis,
            templateKey,
            customerId,
            findOrCreateAnamnesis,
        } = this.props
        if (!anamnesis && templateKey && findOrCreateAnamnesis) {
            findOrCreateAnamnesis(customerId, templateKey)
        }
    },
})(Anamnesis)

Anamnesis.propTypes = {
    skipAuthorization: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/modules/anamnesis/component/anamnesis/Anamnesis.js